const rootActionPath = 'core/EmailOptInSuccessModal';

export const EMAIL_OPT_IN_MODAL_SUCCESS_VIEW = `${rootActionPath}/VIEW`;
